import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_black_diamond.svg';
import Icon, { IconProps } from './icon';

const IconBlackDiamond = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconBlackDiamond;
